// FE-only relabel: venue-facing copy says "event", while the DB, API payloads,
// and field keys keep their original game naming. Apply to display labels only,
// never to values sent back to the backend.
export function gameToEventLabel(str) {
  if (str === null || str === undefined) return str
  return String(str)
    .replace(/game master/gi, m => (m[0] === 'G' ? 'Event host' : 'event host'))
    .replace(/\bGAMES\b/g, 'EVENTS')
    .replace(/\bGames\b/g, 'Events')
    .replace(/\bgames\b/g, 'events')
    .replace(/\bGAME\b/g, 'EVENT')
    .replace(/\bGame\b/g, 'Event')
    .replace(/\bgame\b/g, 'event')
}
